"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsxs)("defs", {
      children: [(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "prefix__a",
        x1: "67.463%",
        x2: "40.934%",
        y1: "40.328%",
        y2: "81.66%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "18%",
          stopColor: "#0052CC"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#2684FF"
        })]
      }), (0, _jsxRuntime.jsxs)("linearGradient", {
        id: "prefix__b",
        x1: "32.778%",
        x2: "59.277%",
        y1: "59.166%",
        y2: "17.99%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "18%",
          stopColor: "#0052CC"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#2684FF"
        })]
      })]
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#2684FF",
        fillRule: "nonzero",
        d: "M27.713 15.694L17.035 5.034 16 4l-8.038 8.025-3.675 3.669a.98.98 0 000 1.386l7.344 7.332L16 28.774l8.038-8.025.124-.124 3.55-3.545a.978.978 0 000-1.386z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__a)",
        d: "M12.308 8.704A6.2 6.2 0 0112.282 0L4.308 8.02l4.34 4.367 3.66-3.683z",
        transform: "translate(4 4)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__b)",
        d: "M15.349 12.387l-3.657 3.67a6.176 6.176 0 010 8.718l8-8.03-4.343-4.358z",
        transform: "translate(4 4)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M15.668 19.996L12 16.333l3.668-3.662 3.669 3.662z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Jira.js.map